export function getView(insurances, insurance_subscriptions) {
  // only show the warning on the initial render when the user hasn't selected an insurance yet
  return (
    insurances.length > 0 &&
    !insurances[0].insured_id &&
    insurance_subscriptions.some(
      item =>
        !item.insurance_subscription.insurance_plan.tx_category_coverages
          ?.ortho_coverages || !item.tx_category_insured?.ortho_insured
    )
  )
}
